import { useEffect } from 'react';

/**
 * P8 — applies a meta object (from content/meta.js) to the document head:
 * title, description, robots, canonical and Open Graph / Twitter tags.
 * Renders nothing.
 */

const setNamed = (name, content) => {
  if (content == null) return;
  let el = document.head.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    el.setAttribute('data-pagemeta', '1');
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const setProp = (prop, content) => {
  if (content == null) return;
  let el = document.head.querySelector(`meta[property="${prop}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('property', prop);
    el.setAttribute('data-pagemeta', '1');
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const setCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    el.setAttribute('data-pagemeta', '1');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

export default function PageMeta({ meta }) {
  useEffect(() => {
    if (!meta) return;
    const canonical = meta.canonical || window.location.origin + window.location.pathname;

    document.title = meta.title;
    setNamed('description', meta.description);
    setNamed('robots', meta.robots || 'index,follow');
    setCanonical(canonical);

    setProp('og:title', meta.og?.title || meta.title);
    setProp('og:description', meta.og?.description || meta.description);
    setProp('og:type', meta.og?.type || 'website');
    setProp('og:url', meta.og?.url || canonical);
    setProp('og:site_name', 'ArtistScanner');

    const image = meta.og?.image;
    if (image) {
      setProp('og:image', image);
      setProp('og:image:width', '1200');
      setProp('og:image:height', '630');
      setNamed('twitter:card', 'summary_large_image');
      setNamed('twitter:image', image);
    } else {
      document.head
        .querySelectorAll(
          'meta[property="og:image"][data-pagemeta], meta[property="og:image:width"][data-pagemeta], meta[property="og:image:height"][data-pagemeta], meta[name="twitter:image"][data-pagemeta]'
        )
        .forEach((e) => e.remove());
      setNamed('twitter:card', 'summary');
    }
    setProp('og:title', meta.og?.title || meta.title);
  }, [meta]);

  return null;
}
